export function formatNumber(num: number): string {
  const billion = 1000000000;
  const million = 1000000;
  const thousand = 1000;

  if (num >= billion)
    return (num / billion).toFixed(1).replace(/\.0$/, "") + "B";
  if (num >= million)
    return (num / million).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= thousand)
    return (num / thousand).toFixed(1).replace(/\.0$/, "") + "K";
  return num.toString();
}
